import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import {UserService} from "../../../../services/user.service";
import {CompanyService} from "../../../../services/company.service";

declare let $: any;
declare let Swal: any;

@Component({
    selector : 'gallery-screen',
    templateUrl:'gallery-screen-component.html'
})
export class GalleryScreenComponent implements OnInit, OnDestroy{

  public imageStr;
  public images=[];
  public galleryRefference;
  public constructor( private _router : Router,public _appData : AppDataService,private _auth : UserService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this.galleryRefference=this._companyService.getUserGallery(this._appData.instagramUser);
    this.galleryRefference.on("child_added", (snapshot, prevChildKey) =>{     
      let date=new Date();
      let myimages=this.images;
      if (!myimages) myimages=[];
      let _messages=snapshot.val();
      let milis=date.getTime()-10*60*1000;//last 10 minutes
      //normal messages
      this.images.unshift(_messages)             
    });


  }
  public addPhoto(){
    this.imageStr = name;
    $('#userGalleryUpdate').click();
  }
  public openScreen(screen){
    this._appData.cellScreen=screen;
  }

  public ngOnDestroy() : any {
  }

  
  public updateUserImage(name: string) {

  }
  public seePhoto(photo){
    Swal.fire({
      imageUrl: photo.url,
    })  
  }

  public userFileEvent(fileInput: any){
    var file = fileInput.target.files[0];
    let filename: string = file.name;
    let newfile = this.imageStr + filename;//.substr(idx,4);
    $('#uploadingModal').modal("show");
    this._auth.uploadToFirebase(file, newfile, 'userprofile/'+this._appData.instagramUser.uid+'/gallery').subscribe(snapshot =>{
      snapshot.ref.getDownloadURL().then(url => {
        let date=new Date();
        let milis=date.getTime();
        this._companyService.addUserGallery(this._appData.instagramUser,{url:url,comments:[],likes:[],date:milis})
        $('#uploadingModal').modal('hide');
      })

    });
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/gallery-screen/gallery-screen-component.ts